"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polygon = void 0;
var Polygon = /** @class */ (function () {
    function Polygon(param) {
        var _this = this;
        // property
        this._array = [];
        // initialize
        if (param) {
            if (typeof param === "number") {
                for (var i = 0; i < param; i++) {
                    this.push(0, 0, false);
                }
            }
            else {
                param.forEach(function (_a) {
                    var x = _a.x, y = _a.y, off = _a.off;
                    _this.push(x, y, off);
                });
            }
        }
    }
    Object.defineProperty(Polygon.prototype, "array", {
        // resolution : 0.1
        get: function () {
            var _this = this;
            return this._array.map(function (_, i) { return _this.get(i); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Polygon.prototype, "length", {
        get: function () {
            return this._array.length;
        },
        enumerable: false,
        configurable: true
    });
    // method
    Polygon.prototype.push = function (x, y, off) {
        if (off === void 0) { off = false; }
        this._array.push({ x: x, y: y, off: off });
    };
    Polygon.prototype.set = function (index, x, y, off) {
        if (off === void 0) { off = false; }
        this._array[index].x = x;
        this._array[index].y = y;
        this._array[index].off = off;
    };
    Polygon.prototype.get = function (index) {
        var _a = this._array[index], x = _a.x, y = _a.y, off = _a.off;
        return {
            x: Math.floor(x * 10) / 10,
            y: Math.floor(y * 10) / 10,
            off: off,
        };
    };
    Polygon.prototype.reverse = function () {
        this._array.reverse();
    };
    Polygon.prototype.concat = function (poly) {
        this._array = this._array.concat(poly._array);
    };
    Polygon.prototype.shift = function () {
        this._array.shift();
    };
    Polygon.prototype.unshift = function (x, y, off) {
        if (off === void 0) { off = false; }
        this._array.unshift({ x: x, y: y, off: off });
    };
    Polygon.prototype.clone = function () {
        var newpolygon = new Polygon();
        this._array.forEach(function (_a) {
            var x = _a.x, y = _a.y, off = _a.off;
            newpolygon.push(x, y, off);
        });
        return newpolygon;
    };
    Polygon.prototype.translate = function (dx, dy) {
        this._array.forEach(function (point) {
            point.x += dx;
            point.y += dy;
        });
        return this; // for chaining
    };
    Polygon.prototype.transformMatrix = function (a, b, c, d) {
        this._array.forEach(function (point) {
            var x = point.x, y = point.y;
            point.x = a * x + b * y;
            point.y = c * x + d * y;
        });
        return this; // for chaining
    };
    /**
     * Scales by hypot(x, y) and rotates by atan2(y, x). Corresponds to multiplying x+yi on complex plane.
     */
    Polygon.prototype.transformMatrix2 = function (x, y) {
        return this.transformMatrix(x, -y, y, x);
    };
    Polygon.prototype.scale = function (factor) {
        this._array.forEach(function (point) {
            point.x *= factor;
            point.y *= factor;
        });
        return this; // for chaining
    };
    Polygon.prototype.reflectX = function () {
        this._array.forEach(function (point) {
            point.x *= -1;
        });
        return this; // for chaining
    };
    Polygon.prototype.reflectY = function () {
        this._array.forEach(function (point) {
            point.y *= -1;
        });
        return this; // for chaining
    };
    Polygon.prototype.rotate90 = function () {
        this._array.forEach(function (point) {
            var x = point.x, y = point.y;
            point.x = -y;
            point.y = x;
        });
        return this;
    };
    Polygon.prototype.rotate180 = function () {
        return this.scale(-1); // for chaining
    };
    Polygon.prototype.rotate270 = function () {
        this._array.forEach(function (point) {
            var x = point.x, y = point.y;
            point.x = y;
            point.y = -x;
        });
        return this;
    };
    // for backward compatibility...
    Polygon.prototype.floor = function () {
        this._array.forEach(function (point) {
            var x = point.x, y = point.y;
            point.x = Math.floor(x);
            point.y = Math.floor(y);
        });
        return this;
    };
    return Polygon;
}());
exports.Polygon = Polygon;
